import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPen, faSave, faUndo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton, BFormInput, BFormTextarea } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { computed, ref } from "vue";
import { useUserStore } from "@/stores/userStore";
import l from "@/utils/localization";
import TextSummary from "@/components/Common/TextSummary.vue";
import StatelessTags from "@/components/TagsMultiselect/StatelessTags.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DetailsLayout',
    props: {
        name: { default: undefined },
        tags: { default: undefined },
        writeable: { type: Boolean, default: true },
        annotation: { default: undefined },
        showAnnotation: { type: Boolean, default: true },
        summarized: { type: Boolean, default: false }
    },
    emits: ["save"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faPen, faSave, faUndo);
        const userStore = useUserStore();
        const { isAnonymous } = storeToRefs(userStore);
        const nameRef = ref(null);
        const editing = ref(false);
        const textSelected = ref(false);
        const localProps = ref({
            name: "",
            annotation: "",
            tags: [],
        });
        const editButtonTitle = computed(() => {
            if (isAnonymous.value) {
                return l("Log in to Rename History");
            }
            else {
                if (props.writeable) {
                    return l("Edit");
                }
                else {
                    return l("Not Editable");
                }
            }
        });
        function onSave() {
            editing.value = false;
            emit("save", localProps.value);
        }
        function onToggle() {
            editing.value = !editing.value;
            localProps.value = {
                name: props.name,
                annotation: props.annotation,
                tags: props.tags,
            };
            if (nameRef.value) {
                nameRef.value.focus();
            }
        }
        function selectText() {
            var _a, _b;
            if (!textSelected.value) {
                (_a = nameRef.value) === null || _a === void 0 ? void 0 : _a.select();
                textSelected.value = true;
            }
            else {
                (_b = nameRef.value) === null || _b === void 0 ? void 0 : _b.focus();
                textSelected.value = false;
            }
        }
        return { __sfc: true, props, emit, userStore, isAnonymous, nameRef, editing, textSelected, localProps, editButtonTitle, onSave, onToggle, selectText, faPen, faSave, faUndo, FontAwesomeIcon, BButton, BFormInput, BFormTextarea, TextSummary, StatelessTags };
    }
});
